import { CheckCircle2, Info } from 'lucide-react';

import { Badge } from '@/modules/ui/components/badge/Badge';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/modules/ui/components/tooltip/Tooltip';

interface SkillBadgeProps {
  isMustHave: boolean;
  summary: string;
  explanation?: string;
}

export const SkillBadge = ({
  summary,
  explanation,
  isMustHave,
}: SkillBadgeProps) => {
  const variant = isMustHave ? 'secondary' : 'outline';
  const icon = isMustHave ? (
    <CheckCircle2 className="size-4" />
  ) : (
    <Info className="size-4" />
  );

  const tag = (
    <Badge variant={variant}>
      {icon}
      {summary}
    </Badge>
  );

  if (explanation) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>{tag}</TooltipTrigger>
        <TooltipContent className="max-w-xs">{explanation}</TooltipContent>
      </Tooltip>
    );
  }

  return tag;
};
